module.exports = __webpack_public_path__ + "img/bg.afc0ed4f.png";